export default __webpack_public_path__ + "static/media/file-video_lightGray3.b92aa20b.svg";